import { db, Meal } from "../utils/db";

// Add a meal
export async function addMeal(meal: Omit<Meal, "id">) {
  return db.meals.add({ ...meal });
}

// Get all meals
export async function getAllMeals() {
  return db.meals.toArray();
}

// Get meal by id
export async function getMeal(id: string) {
  return db.meals.get(id);
}

// Get meals for a specific date (YYYY-MM-DD)
export async function getMealsForDate(isoDate: string) {
  return db.meals.filter((meal) => meal.eatenAt.startsWith(isoDate)).toArray();
}

// Update meal
export async function updateMeal(id: string, updates: Partial<Meal>) {
  return db.meals.update(id, updates);
}

// Delete meal
export async function deleteMeal(id: string) {
  return db.meals.delete(id);
}
